/**
 * Color utility functions for consistent color assignment across the application
 */

export const TAG_COLORS = [
  'bg-blue-100 text-blue-800',
  'bg-green-100 text-green-800',
  'bg-orange-100 text-orange-800',
  'bg-pink-100 text-pink-800',
  'bg-indigo-100 text-indigo-800',
  'bg-red-100 text-red-800',
  'bg-purple-100 text-purple-800',
  'bg-yellow-100 text-yellow-800',
  'bg-teal-100 text-teal-800',
  'bg-cyan-100 text-cyan-800'
]

/**
 * Simple hash function (djb2) for consistent string-to-number conversion
 * @param str - The string to hash
 * @returns A hash number
 */
const hashString = (str: string): number => {
  let hash = 5381
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash) + str.charCodeAt(i)
  }
  return Math.abs(hash)
}

/**
 * Get a consistent color class for a given string (tag, division, etc.)
 * @param value - The string value to get a color for
 * @returns A Tailwind CSS color class string
 */
export const getColorForValue = (value: string): string => {
  const hash = hashString(value)
  const colorIndex = hash % TAG_COLORS.length
  return TAG_COLORS[colorIndex]
}

/**
 * Get a color for a society tag
 * @param tag - The tag name
 * @returns A Tailwind CSS color class string
 */
export const getTagColor = (tag: string): string => {
  return getColorForValue(tag)
}

/**
 * Get a color for a course division
 * @param division - The division name
 * @returns A Tailwind CSS color class string
 */
export const getDivisionColor = (division: string): string => {
  return getColorForValue(division)
}